
        var result = require("!!../../../../node_modules/css-loader/index.js!./social-media.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/social-media/social-media.component.css
// module id = 628
// module chunks = 0